import { render } from "./AttList.vue?vue&type=template&id=4737d09b"
import script from "./AttList.vue?vue&type=script&lang=js"
export * from "./AttList.vue?vue&type=script&lang=js"

import "./AttList.vue?vue&type=style&index=0&id=4737d09b&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__